/**
 * @module file-browser/file-browser-command
 */

import Command from '@ckeditor/ckeditor5-core/src/command';

/**
 * The file browser base command.
 *
 * Override the configName property, and the insertFile method
 *
 * @extends module:core/command~Command
 */
export default class FileBrowserCommand extends Command {
	get configName() {
		return null;
	}

	/**
	 * Executes the command.
	 *
	 * @fires execute
	 */
	async execute() {
		const editor = this.editor;
		const config = editor.config.get( this.configName );
		const select = config && config.select;
		if ( typeof select !== 'function' ) {
			throw new Error(
				`Add a 'select' function for the ${ this.configName } configuration`
			);
		}
		const selection = editor.model.document.selection;
		const element = selection && selection.getSelectedElement();
		const src = element && element.getAttribute( 'src' );

		const result = select( src );
		if ( result instanceof Promise ) {
			result.then( source => this.insertFile( source ) );
		} else {
			this.insertFile( result );
		}
	}

	/**
	 * Inserts the result of the file  browser.
	 *
	 * @param {string[]} result
	 * @returns
	 */
	insertFile( result ) {}
}
